import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/management/')({
  beforeLoad: () => redirect({ to: '/management/stations' }),
  component: () => null,
});
